import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BedrockGuardrailAccountEnforced,
  BedrockGuardrailContentFilterTypes,
  BedrockGuardrailContentPolicyTier,
  BedrockGuardrailDeniedTopics,
  BedrockGuardrailKMSKeyARN,
  BedrockGuardrailManagedWordListTypes,
  BedrockGuardrailOrganizationEnforced,
  BedrockGuardrailPIIEntityActions,
  BedrockGuardrailPIIEntityTypes,
  BedrockGuardrailProfileARN,
  BedrockGuardrailProfileID,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockGuardrailMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
        updatedAt={metadata}
      />
      {BedrockGuardrailContentFilterTypes(metadata)}
      {BedrockGuardrailContentPolicyTier(metadata)}
      {BedrockGuardrailDeniedTopics(metadata)}
      {BedrockGuardrailManagedWordListTypes(metadata)}
      {BedrockGuardrailPIIEntityTypes(metadata)}
      {BedrockGuardrailPIIEntityActions(metadata)}
      {BedrockGuardrailProfileID(metadata)}
      {BedrockGuardrailProfileARN(metadata)}
      {BedrockGuardrailAccountEnforced(metadata)}
      {BedrockGuardrailOrganizationEnforced(metadata)}
      {BedrockGuardrailKMSKeyARN(metadata)}
    </Grid>
  );
};
